import React, { ReactElement } from 'react';
import { Row } from '@dexma/ui-components';

import Dashboard from 'domain/entity/dashboard';
import DashboardLinkHeader from 'adapter/in/dashboards/pages/DashboardLink/Header';
import StyledGrid from 'adapter/in/dashboards/pages/DashboardLink/style';
import withLoading, { ViewState } from 'adapter/in/common/hoc/withLoading';
import GridContainer from 'adapter/in/dashboards/containers/Grid';

export type DashboardLinkPageProps = ViewState<Dashboard> & {
    tags: { label: string; icon: string }[];
    onFullscreen: () => void;
    fullscreenActive: boolean;
    isLandscape: boolean;
};

export const DashboardLinkPage = (props: DashboardLinkPageProps): ReactElement => {
    const { data: dashboard, tags, onFullscreen, fullscreenActive, isLandscape } = props;

    return (
        <StyledGrid fluid isLandscape={isLandscape} data-testid='dashboard'>
            <DashboardLinkHeader
                name={dashboard.name}
                tags={tags}
                onFullscreen={onFullscreen}
                fullscreenActive={fullscreenActive}
                isLandscape={isLandscape}
            />
            <Row className='layout'>
                <GridContainer dashboardId={dashboard.id} isEditEnabled={false} editingLayout={false} />
            </Row>
        </StyledGrid>
    );
};

export default withLoading(DashboardLinkPage);
